import { useEffect, useRef, useState } from 'react';
import './Nosotros.css';
import BANNER from '../assets/images/BANNER2.png';
import IMG1 from '../assets/images/mision1.png';
import IMG2 from '../assets/images/visión2.png';
import IMG3 from '../assets/images/visión3.png';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';
import checkAnim from '../assets/images/check.gif';
import RedNeuronal2 from '../assets/images/Red-Neuronal4.png';

const Nosotros = () => {
  const bloquesRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            // Si quieres que la animación solo se dispare una vez y no se quite:
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 } // Se activa cuando 20% del elemento esté visible
    );

    bloquesRef.current.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);
  const [enviado, setEnviado] = useState(false);
    
      const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
    
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        }).then(() => {
          setEnviado(true);
          form.reset();
          // Opcional: volver a mostrar formulario después de 5s
          // setTimeout(() => setEnviado(false), 5000);
        });
      };

  return (
    <div>
  <div className="nosotros-seccion">
    <div className="nosotros-banner">
      {/*Imagen Inicio Sobre Nosotros*/}
      <img src={BANNER} alt="BANNER" />
    </div>

    {/* Línea divisora entre el banner y el texto */}
    <div className="linea-fina" />

    <div className="nosotros-texto">
      {/*Bloque introducción Sobre Nosotros */}
      {/*Titulo Sección Sobre Nosotros */}
      <h1>Sobre Nosotros</h1>
      {/*Texto Sección Sobre Nosotros */}
      <p>
        En GRUPO IATEKZA somos especialistas en soluciones tecnológicas que impulsan<br></br>
        la transformación digital de tu empresa. Nuestra experiencia y compromiso<br></br>
        nos permite ofrecer servicios de calidad y confianza.
      </p>
    </div>
  </div>


     {[
  {
    //Bloque Mision Sobre Nosotros
    //Titulo Misión Sobre Nosotros 
    title: 'Misión',
    //Texto Misión Sobre Nosotros 
    text: 'Transformar organizaciones mediante soluciones tecnológicas inteligentes y consultoría estratégica personalizada, facilitando la toma de decisiones clave y generando un valor sostenible que impulse el crecimiento real de nuestros clientes.',
    //Imagen Misión Sobre Nosotros 
    img: IMG1,
    reverse: false
  },
  {
    //Bloque Visión Sobre Nosotros
    //Titulo Visión Sobre Nosotros  
    title: 'Visión',
    //Texto Visión Sobre Nosotros 
    text: 'Consolidarnos en infraestructura tecnológica, asesoría empresarial y soluciones fiscales digitales. Nos proyectamos como un socio estratégico confiable que impulsa la transformación digital sostenible de las organizaciones, a través de innovación, excelencia operativa y visión de largo plazo.',
    //Imagen Visión Sobre Nosotros 
    img: IMG2,
    reverse: true
  },
  {
    //Bloque Valores Sobre Nosotros
    //Titulo Valores Sobre Nosotros 
    title: 'Valores',
    //Texto Valores Sobre Nosotros
    text: 'Nuestro compromiso se refleja en la constancia, responsabilidad y dedicación con la que abordamos cada proyecto. Construimos relaciones basadas en la confianza, actuamos con honestidad y promovemos la transparencia en todos nuestros procesos, dentro de un ambiente de respeto, ética profesional y profundo compromiso con nuestros clientes.',
    //Imagen Valores Sobre Nosotros 
    img: IMG3,
    reverse: false
  }
].map((item, i, arr) => (
  <div key={i}>
    {/* Línea superior solo antes del primer bloque */}
    {i === 0 && <div className="linea-fina" />}

    <div
      className={`nosotros-bloque${item.reverse ? ' reverse' : ''}`}
      ref={el => bloquesRef.current[i] = el}
    >
      <div className="nosotros-texto-lado">
        <h2>{item.title}</h2>
        <p>{item.text}</p>
      </div>
      <div className="nosotros-img-lado">
        <img src={item.img} alt={item.title} />
      </div>
    </div>

    {/* Línea entre bloques (no después del último) */}
    {i < arr.length - 1 && <div className="linea-fina" />}
  </div>
))}


     {/*Bloque Botón Casos de Éxito */}
<div className="casos-exito">
  {/*Titulo bloque Botón Casos de Éxito */}
  <h2>Conoce nuestros casos de éxito</h2>
  {/* Botón Casos de Exito */}
  <a href="/CasosExito" className="btn-casos-exito">Ver casos de éxito</a>
</div>

 {/* Contenedor principal del formulario de contacto */}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
    {/* Titulo al enviar*/}
  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>
{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
    <ul>
      {/* IAutomatiza CFDI Colum 3*/}
        <li><a href="/">• IAutomatiza CFDI</a></li>
        {/*Facturacion Electronica Colum 3*/}
        <li><a href="/Facturacion">• Facturación Electronica</a></li>
        {/* Servicio Infraestructura TI colum 2*/}
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Asesoría empresarial colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Soluciones Tecnológicas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
        
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Insta Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
  
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
        {/*Aviso Legal Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
    </div>
    
  );
};

export default Nosotros;
